import React from "react";

import "./Label.scss";

export type LabelProps = {
  cx?: string;
};

export const Label: React.FC<LabelProps> = ({ cx = "", children }) => {
  return (
    <div className={`Label ${cx}`} title={children?.toString()}>
      <span>{children}</span>
    </div>
  );
};
